import 'url-search-params-polyfill';

export const getAllClubLocations = (axiosInstance, clubId) => {
    return axiosInstance.get(`v1/club/${clubId}/locations`);
};

export const getAllClubLocationsWithFacilities = (axiosInstance, clubId) => {
    return axiosInstance.get(`v1/club/${clubId}/locationsWithFacilities`);
};

export const addClubLocation = (axiosInstance, { clubId, ...restLocation }) => {
    const url = `v1/club/${clubId}/locations`;
    return axiosInstance.post(url, {
        locations: [{ ...restLocation }],
    });
};

export const updateClubLocation = (axiosInstance, { clubId, ...restLocation }) => {
    const url = `v1/club/${clubId}/locations`;
    return axiosInstance.put(url, restLocation);
};

export const getClubFacilities = (axiosInstance, { locationId, clubId }) => {
    const url = `v1/club/${clubId}/location/${locationId}/facilities`;
    return axiosInstance.get(url);
};

export const deleteClubLocation = (axiosInstance, { clubId, locationId }) => {
    const url = `/v1/club/${clubId}/locations/${locationId}`;
    return axiosInstance.delete(url);
};

export const addLocationFacility = (axiosInstance, { clubId, locationId, ...facility }) => {
    const url = `/v1/club/${clubId}/location/${locationId}/facilities`;
    return axiosInstance.post(url, {
        facilities: [{ ...facility }],
    });
};

export const archiveClubFacility = (axiosInstance, { clubId, locationId, facilityId }) => {
    const url = `/v1/club/${clubId}/location/${locationId}/facilities/${facilityId}`;
    return axiosInstance.delete(url);
};

export const fetchFacilityCourts = (axiosInstance, { clubId, locationId, facilityId }) => {
    const url = `/v1/club/${clubId}/locations/${locationId}/facilities/${facilityId}/courts`;
    return axiosInstance.get(url);
};

export const addFacilityCourt = (axiosInstance, { court, clubId, locationId, facilityId }) => {
    const url = `v1/club/${clubId}/locations/${locationId}/facilities/${facilityId}/courts`;
    return axiosInstance.post(url, {
        courts: [{ ...court }],
    });
};

export const editFacilityCourt = (axiosInstance, { court: { id, ...restCourt }, clubId, locationId, facilityId }) => {
    const url = `v1/club/${clubId}/locations/${locationId}/facilities/${facilityId}/courts/${id}`;
    return axiosInstance.put(url, restCourt);
};

export const archiveFacilityCourt = (axiosInstance, { courtId, locationId, facilityId, clubId }) => {
    const url = `v1/club/${clubId}/locations/${locationId}/facilities/${facilityId}/courts/${courtId}`;
    return axiosInstance.delete(url);
};

export const updateLocationFacility = (axiosInstance, { clubId, locationId, id, ...restFacility }) => {
    const url = `v1/club/${clubId}/location/${locationId}/facilities/${id}`;
    return axiosInstance.put(url, {
        ...restFacility,
    });
};
